import { useMemo, useState } from 'react';
import { QuarterSelectorProps } from '../types/QuarterSelectorProps';
import SelectBox from 'devextreme-react/select-box';
import { Quarter } from '../types/Quarter';

export default function QuarterSelector(props: QuarterSelectorProps) {

	const quarters = useMemo(() => {
		const quarterList: Quarter[] = [];
		var currentDate = new Date();
		for (let i = 0; i < props.numberOfQuarters; i++) {
			var quarter = Math.floor((currentDate.getMonth() + 3) / 3);
			var year = currentDate.getFullYear();
			var quarterName = "Q" + quarter + " " + year;
			var startMonth = (quarter - 1) * 3;
			var startDate = new Date(year, startMonth, 1);
			var endMonth = startMonth + 2;
			var endDate = new Date(year, endMonth + 1, 0);
			quarterList.push({ startDate, endDate, quarterName });
			currentDate.setMonth(currentDate.getMonth() - 3);
		}
		return quarterList;
	}, []);


	const [selectedQuarter, setSelectedQuarter] = useState(quarters[0]);

	return (
		<SelectBox
			className='quarter-selector'
			value={selectedQuarter.quarterName}
			valueExpr="quarterName"
			displayExpr="quarterName"
			dataSource={quarters}
			onValueChanged={e => {
				const quarter = quarters.find(x => x.quarterName === e.value);
				if (quarter) {
					setSelectedQuarter(quarter);
					props.onSelectionChanged(quarter.startDate, quarter.endDate);
				}
			}}
		/>
	)
} 
